import type { CodeEditorProps } from '../../../components/CodeEditor/CodeEditor';

import { useCallback } from 'react';

import CodeEditor from '../../../components/CodeEditor/CodeEditor';

import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const CodeEditorField = (props: CodeEditorProps) => {
  const field = useFieldContext<string>();
  const errors = useFieldErrors(field.name);

  const onChange = useCallback(
    (value?: string) => {
      if (value) {
        field.handleChange(value);
      }
    },
    [field],
  );

  return (
    <CodeEditor
      {...props}
      value={field.state.value}
      onChange={onChange}
      error={errors}
    />
  );
};

export default CodeEditorField;
